/**
 * US market helper (BC-4427). `isUS` gates US-specific footer/header behaviour
 * in `HomeFooter` and related components.
 */

export const isUS = (countryCode: string): boolean =>
    countryCode.toUpperCase() === 'US';
